import React from "react"
import RubberBand from 'react-reveal/RubberBand';



const AboutMe = () => {
    return (
        <RubberBand left cascade>
            <div className="aboutMe">
                <p className="aboutMeParagraph">I started my software engineering journey in 2017. I began my journey by acquiring my 
                Associate's of Applied Science for Computer Programming at a local college called Chattahoochee Technical College. Two months 
                after graduating, I got accepted to study at Flatiron in Atlanta for Full Stack software engineering. I completed the program 
                and received my certificate of completion in May of 2020. I searched for an opportunity for 4 months before finding my 
                first professional position as a software engineer. I now work full time as a software engineer for the #1 bank in America, 
                JP Morgan Chase. I LOVE my job, and being a professional software engineer is better than I could have ever dreamed of. I 
                get the opportunity to work on technology that is used by millions of customers everyday. I just reached my one year with the company, 
                and I can't wait to see what is in store for the future!
                <br/><br/>
                I consider myself a full stack software engineer, but I tend to favor the front end more than the back end. I love the instant satisfaction that comes along with being a front end developer. 
                I have experience working with technologies such as Java, Python, C#, Ruby, Rails, Javascript, React, Redux, Node.js, MongoDB, SQL, HTML, and CSS. 
                <br/><br/>
                I have always been fascinated with technology. I love the logic, algorithms, and puzzles that come along with programming.</p>
            </div>
        </RubberBand>
    )
}

export default AboutMe